import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {Location} from "@angular/common";

@Component({
    selector: 'app-scholarship',
    templateUrl: './scholarship.component.html',
    styleUrls: ['./scholarship.component.scss']
})
export class ScholarshipComponent implements OnInit {
    activeIndex: number | null = null; // Track active accordion

    accordionData = [
        {
            title: 'Financial Assistance to Needy Students',
            description: 'Dean Students Welfare office provides financial assistance to the needy students of various University Teaching Departments. The university strives to promote the academic excellence of the students who are economically weak, needy, or poor and not able to pay their fees for higher studies, to the students studying in the university\'s teaching departments.'
        },
        {
            title: 'Earn While You Learn Scheme',
            description: 'The spirit of the scheme is based on the idea of enabling needy students to meet a part of their educational expenses with dignity. The scheme provides support to the students for working in University Teaching Departments or performing office-related work for some fixed hours in a week, with remuneration per month.'
        },
    ];

    currentPath: string;

    constructor(private router: Router,
                private location: Location) {
        this.currentPath = this.location.path();
    }

    isActive(path: string): boolean {
        return this.currentPath === path;
    }

    ngOnInit(): void {
    }

    toggleAccordion(index: number) {
        this.activeIndex = this.activeIndex === index ? null : index;
    }

}
